import { useMemo } from 'react'

export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data
    return [
      ...data.vaxiom_persons.map(person => ({
        ...person,
        address: person.contact_method_associations?.[0]?.postal_address,
        type: 'person',
      })),
      ...data.leads_leads.map(lead => ({
        ...lead,
        type: 'lead',
      })),
    ]
  }, [data])
}
